<script>
import { Cubic, TweenLite } from 'gsap';

export default {
	data() {
		return {
			el: '',
			open: false,
		};
	},
	mounted() {
		this.el = this.$parent.$el.querySelector('.ro-nav-parent');
		this.open = this.el.className.indexOf('open') !== -1;
	},
	methods: {
		openSubNav() {
			TweenLite.set(this.el, {
				height: 'auto',
				immediateRender: true,
			});

			// Open
			if (this.el.className.indexOf('open') === -1) {
				this.open = true;
				this.el.classList.add('open');

				TweenLite.from(this.el, 0.5, {
					height: 0,
					ease: Cubic.easeInOut,
				});

			// Close
			} else {
				this.open = false;
				this.el.classList.remove('open');

				TweenLite.to(this.el, 0.5, {
					height: 0,
					ease: Cubic.easeInOut,
				});
			}
		},
	},
};
</script>

<template>
<button
	@click="openSubNav"
	class="ro-nav-item-toggle"
>
	<sky-svg
		name="wedge"
	/>
</button>
</template>

<style lang="sass">
@import '~styles/variables';

.ro-nav-item-toggle {
	$list: (bg-color: transparent, hover: false);
	@include button( $list... );
	height: 55px;
	width: 40px;
	position: absolute;
	right: 0;
	top: 0;
	z-index: 3;

	&:focus {
		background-color: transparent;
	}

	svg {
		height: 11px;
		width: 6px;
		transform: rotate(90deg);

		path {
			fill: #fff;
		}
	}
}
</style>



// WEBPACK FOOTER //
// RoNavItemToggle.vue?0ef7fbc8